import React from "react";
import "./CategoryTabs.css";

const categories = [
  {
    id: "outings",
    label: "Outings",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="9" cy="8" r="3" />
        <circle cx="17" cy="9" r="2.5" />
        <path d="M3.5 19v-1.5A5.5 5.5 0 0 1 9 12h1a5.5 5.5 0 0 1 5.5 5.5V19" />
        <path d="M15 13.5h1.5a4 4 0 0 1 4 4V19" />
      </svg>
    ),
  },
  {
    id: "trainings",
    label: "Trainings",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M2.5 9 12 4l9.5 5L12 14 2.5 9Z" />
        <path d="M6 11.5V16c0 1.8 2.7 3.5 6 3.5s6-1.7 6-3.5v-4.5" />
        <path d="M21.5 9v6" />
      </svg>
    ),
  },
  {
    id: "speakers",
    label: "Speakers",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="8" y="3" width="8" height="13" rx="4" />
        <path d="M5 11a7 7 0 0 0 14 0" />
        <path d="M12 18v3" />
        <path d="M8.5 21h7" />
      </svg>
    ),
  },
  {
    id: "retreats",
    label: "Retreats",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="m3 20 6.5-11 3 5 2.5-4 6 10H3Z" />
        <path d="m8 11 1.5-2.5L11 11" />
      </svg>
    ),
  },
  {
    id: "volunteer",
    label: "Volunteer Events",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20.8 4.8a5.4 5.4 0 0 0-7.6 0L12 6l-1.2-1.2a5.4 5.4 0 0 0-7.6 7.6L12 21l8.8-8.6a5.4 5.4 0 0 0 0-7.6Z" />
      </svg>
    ),
  },
];

function CategoryTabs({ activeCategory, onCategoryChange }) {
  return (
    <section className="category-tabs-section">
      <p className="category-tabs-label">I&apos;m looking for:</p>

      <div
        className="category-tabs"
        role="tablist"
        aria-label="Experience categories"
      >
        {categories.map((category) => {
          const isActive = activeCategory === category.id;

          return (
            <button
              key={category.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`category-tab ${isActive ? "active" : ""}`}
              onClick={() => onCategoryChange(category.id)}
            >
              <span className="category-tab-icon">{category.icon}</span>
              <span>{category.label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default CategoryTabs;
